import { useState, useEffect } from "react";

let listeners = [];
let state = {
  current_coors: {lng: 100.5020106, lat: 13.7526865},
  //current_coors: [],
  user_address_name: "",
  user_address_location: [],
  line_user_profile: null,
  line_user_id: null,
  isShowBanner: true,
  traffy_user_id: "",
};

const setState = (newState) => {
  state = { ...state, ...newState };
  listeners.forEach((listener) => {
    listener(state);
  });
};

const useCustom = () => {
  const newListener = useState()[1];
  useEffect(() => {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};

export default useCustom;
